import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { CalculatorListSkeletonSection } from "web_myplann/Calculators/Components/CalculatorListSkeletonSection";
import { CALCULATOR_SECTIONS } from "web_myplann/Calculators/Utils/calculatorCatalog";

export const CalculatorListSkeleton: FC = () => {
	const theme = useTheme();

	return (
		<Stack minHeight="100%" pb={theme.spacingTokens.xxl}>
			{CALCULATOR_SECTIONS.map((section) => (
				<CalculatorListSkeletonSection key={section.key} section={section} />
			))}
		</Stack>
	);
};
